export default __webpack_public_path__ + "static/media/Snd_g3.0a22fb86.mp3";